var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10c0 4.418-8 12-8 12s-8-7.582-8-12a8 8 0 1 1 16 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 11a1 1 0 1 0 0-2a1 1 0 0 0 0 2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinAlt);
export default __webpack_public_path__ + "static/media/pin-alt.2689122fc60f6cc1490ac9f3ff3afe9b.svg";
export { ForwardRef as ReactComponent };